import { css } from '@linaria/atomic';
import { theme } from '@frontend/theme';

export type TooltipTheme = 'dark' | 'light';

export const tooltipBaseStyle = css`
  border-radius: ${theme.borderRadius.small};
  box-shadow: ${theme.shadows.floating};
  font-weight: ${theme.font.weight.bold};
  font-size: ${theme.font.size.medium};
  max-width: 270px;
  padding: ${theme.spacing(1)};
  z-index: ${theme.zIndex.hints};
`;

export const tooltipThemeStyles: Record<TooltipTheme, string> = {
  dark: css`
    background: ${theme.colors.neutral90};
    color: ${theme.colors.white};
    .tooltip-floating-arrow {
      fill: ${theme.colors.neutral90};
    }
  `,
  light: css`
    background: ${theme.colors.white};
    color: ${theme.colors.neutral90};
    .tooltip-floating-arrow {
      fill: ${theme.colors.white};
    }
  `,
};

export const tooltipTextStyle = css`
  margin: 0;
  font-size: inherit;
  color: inherit;
  line-height: inherit;
`;
